<template>
    <div class="">
        <data-table 
            :columns="ptColumnNames" 
            :tableData="fbpClaimsList" 
            :checkbox="false" 
            :withForm="false" 
            :showinrow="false" 
             >
             <template v-slot:rowcontent="slotprops">
                <img class="sm-img" v-if="slotprops.value.column.key=='imgSrc'" :src="slotprops.value.record[slotprops.value.column.key]"/>
                <p v-if="slotprops.value.column.key!='imgSrc' && slotprops.value.column.key !='attachments'"  >{{slotprops.value.record[slotprops.value.column.key]}}</p>

                <!-- dropdown section starts here -->
                <div class="action-section" v-if="slotprops.value.column.key=='action'"> 
                    <img src="@/assets/group-2.png" @click="dropdown(slotprops.value)" alt="actionIcon">
                    <ul class="action-menu" v-show="fbpClaimsList[slotprops.value.index].showDropDown" >
                        <li><span class="">Change ESS Status </span></li>
                        <li> <span class="">Reset ESS Password </span></li>
                        <li><span class="">Create ESS Login </span></li>
                    </ul>
                </div>
            <!-- dropdown section ends here -->     
            </template>
        </data-table>

        <bottom-action-container class="placeEnd">
            <template slot="end">
                <btn-grp>
                    <btn text="Back" type="secondary" @click="back" />
                    <btn text="Dashboard" type="primary" @click="dashboard" />
                </btn-grp>
            </template>
        </bottom-action-container>
    </div>
</template>
<script>

import {mapState,mapActions,mapGetters} from "vuex"

export default {
  name: 'fbpClaimHistory',
  data(){
        return{
            ptColumnNames: [{
                label: '',
                key: 'imgSrc'
                },
                {
                label: 'Code',
                key: 'code'
                },
                {
                label: 'Name',
                key: 'name'
                },
                {
                label: 'Department',
                key: 'department'
                },
                {
                label: 'Email Id',
                key: 'emailId'
                },
                {
                label: 'Claim Amount',
                key: 'claimAmount'
                },
                {
                 label: "Action",
                 key: "action"
                }
            ],
            fbpClaimsList: [ 
                {
                    id: "7a57bfbb-5aa1-4485-807e-98d991ccc15b",
                    createdBy: null,
                    updatedBy: null,
                    customAttr: null,
                    emp_id: "16447776-58f2-4105-b03f-1790898bf477",
                    month: "JUNE",
                    component: "02dcb416-689f-4bc6-a1a6-1091920f1263",
                    amount: "5000",
                    bills: [],
                    name: null,
                    department: null,
                    emailId: null,
                    created_at: "2019-06-21T13:09:27.246Z",
                    updated_at: "2019-06-21T13:09:27.246Z",
                    showDropDown: false,
                    imgSrc: require("@/assets/user.svg"),
                    code: "RC1234",
                    action: "",
                    department: "IT",
                    claimAmount: "1200",
                    essstatus: "Active",
                },
                {
                    id: "7a57bfbb-5aa1-4485-807e-98d991ccc15b1",
                    createdBy: null,
                    updatedBy: null,
                    customAttr: null,
                    emp_id: "16447776-58f2-4105-b03f-1790898bf477",
                    month: "JUNE",
                    component: "02dcb416-689f-4bc6-a1a6-1091920f1263",
                    amount: "5000",
                    bills: [],
                    name: null,
                    department: null,
                    emailId: null,
                    created_at: "2019-06-21T13:09:27.246Z",
                    updated_at: "2019-06-21T13:09:27.246Z",
                    showDropDown: false,
                    imgSrc: require("@/assets/user.svg"),
                    code: "RC1234",
                    action: "",
                    department: "IT",
                    claimAmount: "1200",
                    essstatus: "Active",
                },
                {
                    id: "7a57bfbb-5aa1-4485-807e-98d991ccc15b2",
                    createdBy: null,
                    updatedBy: null,
                    customAttr: null,
                    emp_id: "16447776-58f2-4105-b03f-1790898bf477",
                    month: "JUNE",
                    component: "02dcb416-689f-4bc6-a1a6-1091920f1263",
                    amount: "5000",
                    bills: [],
                    name: null,
                    department: null,
                    emailId: null,
                    created_at: "2019-06-21T13:09:27.246Z",
                    updated_at: "2019-06-21T13:09:27.246Z",
                    showDropDown: false,
                    imgSrc: require("@/assets/user.svg"),
                    code: "RC1234",
                    action: "",
                    department: "IT",
                    claimAmount: "1200",
                    essstatus: "Active",
                }
            ],
            le_id: "1580822c-764b-11e9-8f9e-2a86e4085a59",
        }
  },
  mounted() {
    //console.log("New component mounted.");
  },
   activated:function(){
      this.fetchFbpClaimsList();
  },
  leId() {
      /*
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
      */
     return "1580822c-764b-11e9-8f9e-2a86e4085a59";
    },
  methods: {
    ...mapActions({
        act_fetchFbpClaims:'dashboard/payroll/utilities/uploadFbpClaim/fetchAll',
    }),

    async fetchFbpClaimsList(){
     try {
         
        let res =  await this.act_fetchFbpClaims(this.le_id);
        //console.log('fetchFbpClaimsList:',res);
        let dataArr = res.data;
        if(dataArr.length ){
            this.fbpClaimsList = dataArr;
        }
      } catch (err) {
        //console.log("intro error", err);
      }
    },

     back() {
      this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        });
    },
    dashboard() {
      
    },
    dropdown(slots) {
        //console.log('slots',slots);
        let idx = this.fbpClaimsList.findIndex(obj => {
        return obj.id == slots.index + 1;
      });
      this.fbpClaimsList.forEach((data, index) => {
        if (index != idx) {
          data.showDropDown = false;
        }
      });
      if (idx > -1) {
        this.fbpClaimsList[slots.index].showDropDown = !this.fbpClaimsList[slots.index].showDropDown;
      }
    },
  }
}
</script>

<style lang="scss" scoped>


.action-section {
  margin: 0px;
  text-align: center;

  img {
    width: auto;
  }
  .action-menu {
    top: 0px;
    right: 54px;
    left: -182px;
    &::before{
        display: none;
    }
    li {
      padding: 0px;
      padding: 10px 25px;
      font-weight: 500;
      &:not(:last-child) {
        border-bottom: solid 1px #97979759;
      }
    }
  }
}
</style>


